import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import CCInsertScreen from './screens/ccInsertScreen/ccInsertScreen';
import DetailsInsertScreen from './screens/detailsInsertScreen/detailsInsertScreen';
import IdInsertScreen from './screens/idInsertScreen/idInsertScreen';
import {pages, saleOTPSteps, saleActiveStep} from '../cellcomAbroadVariables';
import {
  setSaleActiveStep,
  GetShadowSubscriberData,
  GetDebtIssuesIndication,
  UpdateEmailOfCustomer,
  SubmitCreateShadowCustomer,
  UpdateShadowClientCard,
  setShadowFormData,
  setLoading,
  goToPage,
  setShadowCCUpdateMode,
  setSaleOtpStep,
  saveToHistory,
  setShadowProcessStage,
  PlantShadowMemo,
  GetShadowClientBillData,
  setUpdatedCC,
  setNewPaymentShadow,
  setOtpPopupData,
  setBackupCG,
  setShadowFromExisting,
} from '../cellcomAbroadBlockSlice';
import {resetStore} from '../../SaleBlock/PaymentCG/PaymentCGSlice';
import Config from '../../../../Config';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';

const SeparatedSale = (props) => {
  /** STATE **/
  const [displayUpdateCCPopup, setCCPopup] = useState(false);

  /** COMPONENT DID MOUNT **/

  useEffect(() => {
    if (
      !props.subscriberData.otpPhone ||
      !props.subscriberData.validatedCostumerData ||
      !props.subscriberData.validatedCostumerData?.shadowData ||
      props.subscriberData.validatedCostumerData?.shadowData?.ban == '-1'
    )
      props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath); //kicks client out if he doesn't belong

    props.resetStore(); //resetting paymentCG
    if ((window.location.hash == '' || window.location.hash == '#') && !props.data.shadowCCInUpdate) {
      const shadowData = props.subscriberData.validatedCostumerData?.shadowData;
      if (!shadowData?.shadowClientValid || (!shadowData.effectiveSocExists && shadowData.status.toUpperCase() == 'S')) {
        if (props.data.shadowProcessStage != DETAILS_INSERT) props.setShadowProcessStage(DETAILS_INSERT);
      } else {
        if (props.data.shadowProcessStage != ID_INSERT) props.setShadowProcessStage(ID_INSERT);
      }
    } else {
      if (window.location.hash == '#reg_payment' || window.location.hash == 'update_payment') {
        if (props.data.shadowProcessStage != CC_INSERT) props.setShadowProcessStage(CC_INSERT);
      }
    }
    props.saveToHistory();
  }, []);

  /** SCREEN CONSTANTS **/
  const ID_INSERT = 'ID_INSERT';
  const DETAILS_INSERT = 'DETAILS_INSERT';
  const CC_INSERT = 'CC_INSERT';

  /** COMPONENT METHODS **/

  const checkMoveForDetailInsert = (newId) => {
    props
      .GetDebtIssuesIndication({
        id: newId,
        subscriber: props.subscriberData.otpPhone,
        fromExisting: props.subscriberData?.validatedCostumerData?.shadowData?.shadowClientValid,
      })
      .then((res) => {
        const debtChecker = res.payload.Body;
        if (!debtChecker && debtChecker != null) {
          props.setShadowFormData({
            customerId: newId,
            customerFirstName: '',
            customerLastName: '',
            customerEmail: '',
          });
          props.setShadowFromExisting(true);
        } else {
          props.setShadowFromExisting(false);
        }
        props.setShadowProcessStage(DETAILS_INSERT);
      });
  };

  const moveToTicket = () => {
    props.setSaleActiveStep(saleActiveStep.TICKET);
    props.setSaleOtpStep(saleOTPSteps.AFTER_INPUT);
    props.goToPage(pages.SALE);
    props.setOtpPopupData(null);
    props.context.navigateTo(props.data.epiStyleInitializationData.urlToSaleBlock);
  };

  const idHandler = async (id) => {
    await props.setShadowFormData({
      customerId: id,
      customerFirstName: '',
      customerLastName: '',
      customerEmail: '',
    });
    moveToTicket();
  };

  const detailsHandler = (obj) => {
    props.setShadowFormData(obj).then(() => {
      props.saveToHistory();
      props.setShadowProcessStage(CC_INSERT);
      props.saveToHistory('reg_personal');
    });
  };

  const ccHandler = () => {
    if (
      props.data.otpData.validatedCostumerData.shadowData.ban &&
      props.data.otpData.validatedCostumerData.shadowData.ban != '0' &&
      props.data.otpData.validatedCostumerData.shadowData.ban != '-1' &&
      props.data.otpData.validatedCostumerData.shadowData.status != 'N' &&
      props.data.shadowForm.customerEmail == ''
    ) {
      props
        .UpdateShadowClientCard({
          ccMonth: props.paymentData.form.CardDueMonth,
          ccYear: props.paymentData.form.CardDueYear,
          ccType: props.paymentData.CCType,
          ccNumber: props.paymentData.CCToken,
          banId: props.data.otpData.validatedCostumerData.shadowData.ban,
          clientId: props.data.shadowForm.customerId,
          subscriber: props.subscriberData.otpPhone,
          authNo: props.paymentData.CGData.authNumber,
        })
        .then((res) => {
          if (res.payload.Body.success) {
            props.saveToHistory('update_payment').then(() => {
              props.setShadowCCUpdateMode(false);
              props.setUpdatedCC(true);
              props.setNewPaymentShadow(props.paymentData.Credit4Digits.replace(/x/g, ''));
              moveToTicket();
            });
          } else {
            setCCPopup(true);
            gaEvent(
              gaParams.SEPARATED_CCUPDATEFAILED_SHOW.category,
              gaParams.SEPARATED_CCUPDATEFAILED_SHOW.eventType,
              gaParams.SEPARATED_CCUPDATEFAILED_SHOW.eventParams,
            );
          }
        });
    } else {
      ///todo - ifs in case of back, when data is already present
      props.setBackupCG(props.paymentData);
      const savingArg = props.data.shadowCCInUpdate ? 'update_payment' : 'reg_payment';
      props.saveToHistory(savingArg).then(() => {
        props.setShadowCCUpdateMode(false);
        moveToTicket();
      });
    }
  };

  const getTermsPDFUrl = () => {
    return `${Config.epiBaseUrl + props.iContent?.pdfSeparatedSaleAgreement?.value?.url}`;
  };

  const selectMode = () => {
    if (props.data.shadowCCInUpdate) {
      return (
        <CCInsertScreen
          handler={ccHandler}
          subscriber={props.subscriberData.otpPhone}
          customerId={props.data.shadowForm.customerId}
          popupUpdate={displayUpdateCCPopup}
          ticketMove={moveToTicket}
          popupUpdateSet={setCCPopup}
          canProceed={props.data.shadowUpdatedCC || !props.data.shadowClientBillData?.shouldUpdate}
          termsUrl={getTermsPDFUrl()}
        />
      );
    } else {
      switch (props.data.shadowProcessStage) {
        case ID_INSERT:
          return (
            <IdInsertScreen
              isLoading={props.data.isLoading}
              soc={props.data.selectedAbroadPackage.socCode}
              ticketId={props.subscriberData.step1Ticket}
              isJET={props.data.isJETAuthentication}
              PlantMemo={props.PlantShadowMemo}
              subscriber={props.subscriberData.otpPhone}
              data={props.subscriberData.validatedCostumerData?.shadowData}
              billingData={props.data.shadowClientBillData}
              BillingCheck={props.GetShadowClientBillData}
              handler={idHandler}
              goToDetailInsert={checkMoveForDetailInsert}
            />
          );
        case DETAILS_INSERT:
          return (
            <DetailsInsertScreen
              customerId={props.data.shadowForm.customerId}
              subscriber={props.subscriberData.otpPhone}
              isJET={props.data.isJETAuthentication}
              handler={detailsHandler}
              subscriberData={props.subscriberData}
              debtCheck={props.GetDebtIssuesIndication}
              customerFirstName={props.data.shadowForm.customerFirstName}
              customerLastName={props.data.shadowForm.customerLastName}
              customerEmail={props.data.shadowForm.customerEmail}
              lockId={props.data.shadowNewFromExisting}
            />
          );
        case CC_INSERT:
          return (
            <CCInsertScreen
              subscriber={props.subscriberData.otpPhone}
              handler={ccHandler}
              customerId={props.data.shadowForm.customerId}
              popupUpdate={displayUpdateCCPopup}
              ticketMove={moveToTicket}
              popupUpdateSet={setCCPopup}
              canProceed={props.data.shadowUpdatedCC || !props.data.shadowClientBillData?.shouldUpdate}
              termsUrl={getTermsPDFUrl()}
            />
          );
      }
    }
    return null;
  };

  /** COMPONENT RENDER **/
  return selectMode();
};

const mapStateToProps = (state) => {
  return {
    subscriberData: state.cellcomAbroad.otpData,
    data: state.cellcomAbroad,
    paymentData: state.PaymentCG,
  };
};

const mapDispatchToProps = {
  setSaleActiveStep,
  GetShadowSubscriberData,
  GetDebtIssuesIndication,
  UpdateEmailOfCustomer,
  SubmitCreateShadowCustomer,
  UpdateShadowClientCard,
  setShadowFormData,
  goToPage,
  setLoading,
  setShadowCCUpdateMode,
  setSaleOtpStep,
  saveToHistory,
  setShadowProcessStage,
  resetStore,
  PlantShadowMemo,
  GetShadowClientBillData,
  setUpdatedCC,
  setNewPaymentShadow,
  setOtpPopupData,
  setBackupCG,
  setShadowFromExisting,
};

export default connect(mapStateToProps, mapDispatchToProps)(SeparatedSale);
